import {AbstractVisualFeature} from '../../visual-feature.js';
import {CardsAndPromotions} from '../cards-and-promotions.js';

import {promotionsFactory} from './promotions.factory.js';

import SCHEMA from './promotions.schema.yaml';
import PALETTE_SCHEMA from './promotions.palette-schema.yaml';

class PromotionsFeature extends AbstractVisualFeature {
    get name() {
        return 'Promotions';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return {
            HomePage: {
                topBannerPromotions: {
                    view: {
                        bannerSkeletons: {
                            bannerSkeletonContainer: {
                                style: {
                                    // Keep the same aspect ratio as set for BannerPromotionsView.banner.image.style.aspectRatio
                                    aspectRatio: this.config.aspectRatio,
                                    _mobile_aspectRatio: this.config.mobileAspectRatio,
                                },
                            },
                        },
                        swiper: {
                            slide: {
                                style: {
                                    aspectRatio: this.config.aspectRatio,
                                    _mobile_aspectRatio: this.config.mobileAspectRatio,
                                },
                            },
                        },
                        banner: {
                            image: {
                                style: {
                                    aspectRatio: this.config.aspectRatio,
                                    _mobile_aspectRatio: this.config.mobileAspectRatio,
                                    _mobile_objectFit: 'inherit',
                                },
                            },
                        },
                    },
                },
            },
            ...promotionsFactory(PALETTE),
        };
    }
}

new PromotionsFeature(CardsAndPromotions);
